import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Input, Typography} from "@material-tailwind/react";
import React, {useContext} from "react";
import Dict from "../../helper/dict";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {bankPayment} from "../../services/payment/payment";
import {parseInt} from "lodash";
import {ServiceContext} from "./service_context";

export function ChargeWalletForm() {

  const {
    service,
    modalOpen,
    setModalOpen,
    setStep,
    setLastDataRefresh,
    chargeAmount,
    setChargeAmount,
    chargeDiscountCode
  } = useContext(ServiceContext);


  const handleOpen = () => setModalOpen(!modalOpen);

  const bank_payment = async () => {
    const data = {
      amount: parseInt(chargeAmount),
      description: "service"
    };

    let result;
    result = await bankPayment(data)
    if (result.status === 200) {
      const {code, id} = result.data;
      localStorage.setItem("transaction_id", id)
      localStorage.setItem("service", JSON.stringify(service))
      localStorage.setItem("discountCode", chargeDiscountCode)
      window.location.href = "https://api.payping.ir/v2/pay/gotoipg/" + code;
    }
  };

  return (
    <>
      <Dialog size="l" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen mt-20">
        <DialogHeader className="bg-gray-800 rounded-2xl -mt-4">
          <Typography className="py-8 w-full text-white text-2xl z-10 textCenter">
            شارژ کیف پول
          </Typography>
        </DialogHeader>

        <DialogBody className="flex flex-col gap-4 overflow-y-scroll">

          <div className="relative flex flex-row mb-4 w-full mx-2">
            <Input variant="standard"
                   size="lg"
                   className="flex flex-col w-1/2"
                   value={chargeAmount}
                   label={Dict('charge_amount')}
                   placeholder={Dict('charge_amount')}
                   onChange={(e) => {
                     setChargeAmount(e.target.value);
                   }}
            />
            <Button variant="gradient" size="l" color="gray" onClick={bank_payment}
                    className="!absolute left-1 top-1 rounded text-center">
              ورود به درگاه بانکی
            </Button>
          </div>
          {chargeAmount && persianNumberFormat(chargeAmount).length > 0 &&
            <div className="flex flex-row mb-4 w-full mx-2">
              <Typography variant="standard"
                          className="flex flex-col w-1/2"
                          color="blue-gray"
              >
                {persianNumberFormat(chargeAmount, true) + " ریال"}
              </Typography>
            </div>
          }

        </DialogBody>

        <DialogFooter className="justify-end -mt-4">
          <div className=" flex flex-row left-0">
            <Button variant="text" color="gray" onClick={() => {
              setStep("invoice")
            }}>
              <span>بازگشت</span>
            </Button>
          </div>
        </DialogFooter>
      </Dialog>
    </>
  );
}
